import * as sidebar from "../../sidebar/index";
import {SaleModel} from "../../common/model/salemodel";
import {initSaleAdminPanelForList} from "../../common/adminpanel";
import 'lib/adaptivefontsize';

/**
 *
 * @param {object} options
 */
export function init(options) {
    const o = {
        pages: [],
        ...options
    };

	sidebar.init({
        heightTarget: '#salesWrapper'
    });

	initCustomSelect ();
	initList(o.pages);
	initSaleAdminPanelForList('#salesWrapper', '.admin-area');
}

function initCustomSelect() {
    $('.sort-wrapper').find('select[rel=chosen]').chosen();
}

function initList(pages) {
	const model = new ListViewModel(pages, (element) => {
		$(element).find('.sale-name-inner').adaptiveFontSize({
			done: (el) => {
				$(el).parent().css('opacity', 1);
			}
		});
		setTimeout(() => {
			// update last comments in sidebar
			$(document).trigger('heightTargetUpdated');
		});
	});

	ko.applyBindings(model, $('#salesWrapper')[0]);
	model.postInit();

	return model;
}

class ListViewModel {
    _$wrapper = $('.sales-wrapper');
    _itemsLoadedCallback = null;
    _scroll = null;
    pages = new ko.observableArray();

	/**
	 *
	 * @param {object[]} pages
	 * @param {function} itemsLoadedCallback Called for each rendered item, accepts DOM Element as parameter
	 */
	constructor(pages, itemsLoadedCallback = null) {
        const SEEN_ARRAY_KEY = 'blog_sale_seen';
        const SEEN_ARRAY_MAX_LENGTH = 200;

        let seenArray = null;

        const readSeenArray = () => {
            const valueStored = localStorage.getItem(SEEN_ARRAY_KEY);
            try {
                seenArray = (valueStored !== null) ? JSON.parse(valueStored) : [];
            } catch(e) {
                seenArray = [];
            }
        };

        const writeSeenArray = () => {
            if(seenArray.length > SEEN_ARRAY_MAX_LENGTH) {
                seenArray = seenArray.slice(0, SEEN_ARRAY_MAX_LENGTH);
            }
            localStorage.setItem(SEEN_ARRAY_KEY, JSON.stringify(seenArray));
        };

        this._itemsLoadedCallback = itemsLoadedCallback;

        readSeenArray();
		pages.forEach(item => {
			this.pages.push(new SaleItem(item, seenArray));
		});
        writeSeenArray();

        this._scroll = this._$wrapper.zInfiniteScroll(
            {
                selector: '.sale-item',
                checkViewport: false,
                enabled: true,
                autoStart: false,
                maxAutoloadPages: 100,
                getCurrentCount: () => this.pages().length,
                totalCount: this._$wrapper.data('count'),
                countPerPage: this._$wrapper.data('count-per-page'),
                loading: '#pagesScrollLoader',
                fetch: (page, callback) => {
                    $.get(
                        this._$wrapper.data('load-url'),
                        {
                            page: page,
                            type: this._$wrapper.data('blog-type'),
                            category: $('.category-filter-item:checked')
                                .map(function() {return $(this).data('slug'); }).get().join(','),
                            blog_sort_by: $('#sortSelect').val(),
                            blog_shop_filter: $('#shopSearch').val(),
                            blog_date_filter: $('#filterSelect').val()
                        },
                        (response) => {
                            if(response.archiveCount !== undefined) {
                                $('#archiveButtonCounter').text(response.archiveCount);
                            }
                            callback(response.pages);
                        },
                        'json'
                    );
                },
                clear: () => {
                    this.pages.removeAll();
                },
                show: (items) => {
                    readSeenArray();
	                items.forEach(item => {
	                	this.pages.push(new SaleItem(item, seenArray));
	                });
                    writeSeenArray();
                    return items.length;
                },
                finished: () => {
                    $('#archiveButton').css('display','inline-block');
                }
            }
        );

        $(document).on('reloadSales', () => {
            $('#archiveButton').hide();
            this._scroll.reload();
        });
    }

	/**
	 *
	 * @param {Element} element
	 * @param {SaleItem} data
	 */
	afterRender = (element, data) => {
        if($.isFunction(this._itemsLoadedCallback)) {
			const $item = $(element).filter('.sale-item');
	        setTimeout(() => {
		        this._itemsLoadedCallback($item[0]);
	        });
        }
    };

    postInit() {
        this._scroll.on();
    }
}

class SaleItem extends SaleModel {
    constructor(item, seenArray) {
        super(item);

        this.multicolumn = this.details_type == 'multicolumn';
        this.seen = (seenArray.indexOf(this.page_id) != -1);

        if(!this.seen) {
            seenArray.unshift(this.page_id);
        }

        if(this.discount_code) {
            this.discount_code = `Скидочный код: ${this.discount_code}`;
        }

        this.isPureImageBanner = this.isImageBanner && !this.details_content_columns.length;
    }
}



// WEBPACK FOOTER //
// ./modules/blog/list/sale/index.js